import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API}/api`,
  withCredentials: true,
});

// Clients
export const getClients = () => api.get('/clients');
export const getClient = (id) => api.get(`/clients/${id}`);
export const createClient = (data) => api.post('/clients', data);
export const updateClient = (id, data) => api.put(`/clients/${id}`, data);
export const deleteClient = (id) => api.delete(`/clients/${id}`);

// Campaigns
export const getCampaigns = () => api.get('/campaigns');
export const getCampaign = (id) => api.get(`/campaigns/${id}`);
export const createCampaign = (data) => api.post('/campaigns', data);
export const updateCampaign = (id, data) => api.put(`/campaigns/${id}`, data);
export const deleteCampaign = (id) => api.delete(`/campaigns/${id}`);

// Payments
export const getPayments = () => api.get('/payments');
export const createPayment = (data) => api.post('/payments', data);
export const updatePayment = (id, data) => api.put(`/payments/${id}`, data);
export const deletePayment = (id) => api.delete(`/payments/${id}`);

// Dashboard
export const getDashboardStats = (params) => api.get('/dashboard/stats', { params });

// Team (admin)
export const getTeam = () => api.get('/team');
export const createTeamMember = (data) => api.post('/team', data);
export const updateTeamMember = (id, data) => api.put(`/team/${id}`, data);
export const deleteTeamMember = (id) => api.delete(`/team/${id}`);
export const resetTeamMemberPassword = (id, newPassword) => api.put(`/team/${id}/reset-password`, { new_password: newPassword });

// Alerts
export const getAlerts = () => api.get('/alerts');
export const createAlert = (data) => api.post('/alerts', data);
export const updateAlert = (id, data) => api.put(`/alerts/${id}`, data);
export const deleteAlert = (id) => api.delete(`/alerts/${id}`);
export const testAlert = (id) => api.post(`/alerts/${id}/test`);
export const evaluateAlerts = () => api.post('/alerts/evaluate');

// Invoice Requests
export const requestInvoice = (data) => api.post('/invoices/request', data);
export const getInvoiceRequests = () => api.get('/invoices');
export const raiseInvoice = (id) => api.put(`/invoices/${id}/raise`);

// Bulk operations & CSV import
export const bulkDeleteCampaigns = (ids) => api.post('/campaigns/bulk-delete', { campaign_ids: ids });
export const importCampaignsCSV = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/campaigns/import-csv', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Activity log
export const getActivityLog = (campaignId) => api.get('/activity-log', { params: campaignId ? { campaign_id: campaignId } : {} });

// CSV Exports
export const exportCampaignsCSV = () => `${API}/api/campaigns/export/csv`;
export const exportClientsCSV = () => `${API}/api/clients/export/csv`;

export default api;
